import forEachSelector from './elements/forEachSelector';
import addTargetEventListener from './events/addTargetEventListener';
import SearchComponent from './search/searchComponent';
import 'element-closest-polyfill';

const SEARCH_FORM = 'mc-search-form';
const NAVBAR_SEARCH_FORM = 'mc-navbar__search';
const SEARCH__CLOSE = 'mc-search-form__close';
const SEARCH_LINK = 'mc-nav-item__content';

function handleOutsideFormClick(event) {
  const clickedCloseButton = event.target.classList.contains(SEARCH__CLOSE);
  const clickedForm = event.target.closest(`.${SEARCH_FORM}`);
  forEachSelector(`.${SEARCH_FORM}`, (el) => {
    if(clickedForm !== el || clickedCloseButton) {
      const searchInstance = SearchComponent.getInstance(el);
      searchInstance && searchInstance.close();
    }
  });
}

function handleFormInput(event) {
  const searchInstance = SearchComponent.getInstance(event.target);
  searchInstance && searchInstance.search(event.target.value.toLowerCase());
}

function handleFormSubmit(event) {
  if(!event.target.getAttribute('action')) {
    event.preventDefault();
    const searchInstance = SearchComponent.getInstance(event.target);
    searchInstance && searchInstance.clickFirst();
  }
}

function expandSearchBox() {
  document.querySelector(`.${NAVBAR_SEARCH_FORM}`).classList.add('mc-navbar__search--expanded');
}

function collapseSearchBox(event) {
  // stop if dropdown link is clicked
  if (event.relatedTarget !== null && event.relatedTarget.classList.contains(SEARCH_LINK)) {
    return;
  }
  // prevents collapsing if browser tab is changed
  if (event.target !== document.activeElement) {
    document.querySelector(`.${NAVBAR_SEARCH_FORM}`).classList.remove('mc-navbar__search--expanded');
  }
}

addTargetEventListener('focusout', `.${NAVBAR_SEARCH_FORM} input`, collapseSearchBox);
addTargetEventListener('focusin', `.${NAVBAR_SEARCH_FORM} input`, expandSearchBox);
addTargetEventListener('focusin', `.${SEARCH_FORM} input`, handleFormInput);
addTargetEventListener('input', `.${SEARCH_FORM} input`, handleFormInput);
addTargetEventListener('submit', `.${SEARCH_FORM}`, handleFormSubmit);

['mousedown', 'touchstart', 'click'].forEach(eventName => {
  window.addEventListener(eventName, handleOutsideFormClick);
});
